const system =
    {
        // 官网地址
        // baseApiUrl: 'https://www.weetionyun.com/',
        baseApiUrl: 'https://www.weetionyun.com/'
    }

export default system